<template>
  <!-- En Vue 3 `$attrs` ya incluye los listeners (`onClick`...), asi que un solo
       v-bind reenvia class/style/aria-* y eventos al SVG interno; `$listeners`
       ya no existe. `inheritAttrs: false` evita que se apliquen dos veces. -->
  <component :is="componentMap[name]" v-bind="$attrs" />
</template>

<script>
import { markRaw } from "vue";
// 1. Importem els components normalment
import Icon360 from "./Icon360.vue";
import IconAccountBalanceWallet from "./IconAccountBalanceWallet.vue";
import IconAdd from "./IconAdd.vue";
import IconAddShoppingCart from "./IconAddShoppingCart.vue";
import IconArchitecture from "./IconArchitecture.vue";
import IconArrowForward from "./IconArrowForward.vue";
import IconAspectRatio from "./IconAspectRatio.vue";
import IconAssignmentTurnedIn from "./IconAssignmentTurnedIn.vue";
import IconBookmark from "./IconBookmark.vue";
import IconBuild from "./IconBuild.vue";
import IconCalendarMonth from "./IconCalendarMonth.vue";
import IconCheckCircle from "./IconCheckCircle.vue";
import IconChevronLeft from "./IconChevronLeft.vue";
import IconChevronRight from "./IconChevronRight.vue";
import IconClose from "./IconClose.vue";
import IconConstruction from "./IconConstruction.vue";
import IconDelete from "./IconDelete.vue";
import IconDescription from "./IconDescription.vue";
import IconDownload from "./IconDownload.vue";
import IconEco from "./IconEco.vue";
import IconEdit from "./IconEdit.vue";
import IconEditNote from "./IconEditNote.vue";
import IconError from "./IconError.vue";
import IconExpandMore from "./IconExpandMore.vue";
import IconFactCheck from "./IconFactCheck.vue";
import IconFilterList from "./IconFilterList.vue";
import IconFolderOpen from "./IconFolderOpen.vue";
import IconGavel from "./IconGavel.vue";
import IconGridView from "./IconGridView.vue";
import IconHome from "./IconHome.vue";
import IconImportContacts from "./IconImportContacts.vue";
import IconInfo from "./IconInfo.vue";
import IconLabel from "./IconLabel.vue";
import IconLightbulb from "./IconLightbulb.vue";
import IconLocalShipping from "./IconLocalShipping.vue";
import IconLocationOn from "./IconLocationOn.vue";
import IconMenuBook from "./IconMenuBook.vue";
import IconNature from "./IconNature.vue";
import IconPark from "./IconPark.vue";
import IconPayments from "./IconPayments.vue";
import IconReceiptLong from "./IconReceiptLong.vue";
import IconRecycling from "./IconRecycling.vue";
import IconRemove from "./IconRemove.vue";
import IconSchedule from "./IconSchedule.vue";
import IconSchema from "./IconSchema.vue";
import IconSearch from "./IconSearch.vue";
import IconSearchOff from "./IconSearchOff.vue";
import IconShield from "./IconShield.vue";
import IconShoppingBag from "./IconShoppingBag.vue";
import IconStore from "./IconStore.vue";
import IconStraighten from "./IconStraighten.vue";
import IconSync from "./IconSync.vue";
import IconTaskAlt from "./IconTaskAlt.vue";
import IconTrophy from "./IconTrophy.vue";
import IconTune from "./IconTune.vue";
import IconVerified from "./IconVerified.vue";
import IconVerifiedUser from "./IconVerifiedUser.vue";
import IconVideocam from "./IconVideocam.vue";
import IconVisibility from "./IconVisibility.vue";
import IconVisibilityOff from "./IconVisibilityOff.vue";
import IconWarning from "./IconWarning.vue";
import IconWorkspacePremium from "./IconWorkspacePremium.vue";
import IconZoomIn from "./IconZoomIn.vue";

export default {
  name: "XIcons",
  inheritAttrs: false,
  // 2. Definim les props a l'estil Vue 2
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  // 3. Registrem els components perquè es puguin utilitzar
  components: {
    IconHome,
    IconShoppingBag,
    IconStore,
    IconSearch,
    IconVisibility,
    IconVisibilityOff,
    IconFilterList,
    IconChevronLeft,
    IconChevronRight,
    IconSearchOff,
    IconExpandMore,
    IconGridView,
    IconCheckCircle,
    IconDelete,
    IconAdd,
    IconBookmark,
    IconAddShoppingCart,
    IconDescription,
    IconError,
    IconArrowForward,
    IconTrophy,
    IconClose,
    IconLocationOn,
    IconPayments,
    IconReceiptLong,
    IconAccountBalanceWallet,
    IconSync,
    IconCalendarMonth,
    IconEditNote,
    IconSchedule,
    IconLocalShipping,
    IconTaskAlt,
    IconEdit,
    IconVerified,
    IconWarning,
    IconRemove,
    IconTune,
    IconDownload,
    IconBuild,
    IconArchitecture,
    IconWorkspacePremium,
    IconFactCheck,
    IconStraighten,
    IconLightbulb,
    IconInfo,
    IconAspectRatio,
    IconFolderOpen,
    IconSchema,
    IconMenuBook,
    IconConstruction,
    IconZoomIn,
    IconImportContacts,
    IconFactCheck,
    IconLabel,
    IconEco,
    IconVideocam,
    Icon360,
    IconRecycling,
    IconAssignmentTurnedIn,
    IconVerifiedUser,
    IconPark,
    IconNature,
    IconGavel,
    IconShield,
  },
  data() {
    return {
      // 4. Fem un mapa per traduir el text 'home' al component real.
      //    `markRaw`: en Vue 3 `data()` es reactiu, i sense aixo Vue embolcalla
      //    els 63 components en un proxy reactiu i avisa per consola a cada
      //    pagina ("received a Component that was made a reactive object").
      componentMap: markRaw({
        home: IconHome,
        shopping_bag: IconShoppingBag,
        store: IconStore,
        search: IconSearch,
        visibility: IconVisibility,
        visibility_off: IconVisibilityOff,
        filter_list: IconFilterList,
        chevron_left: IconChevronLeft,
        chevron_right: IconChevronRight,
        search_off: IconSearchOff,
        expand_more: IconExpandMore,
        grid_view: IconGridView,
        check_circle: IconCheckCircle,
        delete: IconDelete,
        add: IconAdd,
        bookmark: IconBookmark,
        add_shopping_cart: IconAddShoppingCart,
        description: IconDescription,
        error: IconError,
        arrow_forward: IconArrowForward,
        trophy: IconTrophy,
        close: IconClose,
        location_on: IconLocationOn,
        payments: IconPayments,
        receipt_long: IconReceiptLong,
        account_balance_wallet: IconAccountBalanceWallet,
        sync: IconSync,
        calendar_month: IconCalendarMonth,
        edit_note: IconEditNote,
        schedule: IconSchedule,
        local_shipping: IconLocalShipping,
        task_alt: IconTaskAlt,
        edit: IconEdit,
        verified: IconVerified,
        warning: IconWarning,
        remove: IconRemove,
        tune: IconTune,
        download: IconDownload,
        build: IconBuild,
        architecture: IconArchitecture,
        workspace_premium: IconWorkspacePremium,
        fact_check: IconFactCheck,
        straighten: IconStraighten,
        lightbulb: IconLightbulb,
        info: IconInfo,
        aspect_ratio: IconAspectRatio,
        folder_open: IconFolderOpen,
        schema: IconSchema,
        menu_book: IconMenuBook,
        construction: IconConstruction,
        zoom_in: IconZoomIn,
        import_contacts: IconImportContacts,
        fact_check: IconFactCheck,
        label: IconLabel,
        eco: IconEco,
        videocam: IconVideocam,
        "360": Icon360,
        recycling: IconRecycling,
        assignment_turned_in: IconAssignmentTurnedIn,
        verified_user: IconVerifiedUser,
        park: IconPark,
        nature: IconNature,
        gavel: IconGavel,
        shield: IconShield,
      }),
    };
  },
};
</script>
